// extracted by mini-css-extract-plugin
export default {"xs":"y6KuKy","container":"C1nffB","lg":"xfOuzh","content":"N9qBIv"};